import { normalizeToSimpleFeatures } from "@/tactical/io/gisNormalize";

function parseXml(text: string): Document {
  const doc = new DOMParser().parseFromString(text, "text/xml");
  const err = doc.querySelector("parsererror");
  if (err) throw new Error("Невалидный XML/KML");
  return doc;
}

/** KML text → простые GeoJSON Feature. */
export async function parseKmlText(text: string): Promise<{
  features: GeoJSON.Feature[];
  skipped: number;
}> {
  const { kml } = await import("@tmcw/togeojson");
  const gj = kml(parseXml(text));
  return normalizeToSimpleFeatures(gj);
}

/** KMZ (ZIP с .kml) → Feature[]. */
export async function parseKmzArrayBuffer(buf: ArrayBuffer): Promise<{
  features: GeoJSON.Feature[];
  skipped: number;
}> {
  const JSZip = (await import("jszip")).default;
  const zip = await JSZip.loadAsync(buf);
  const entry = Object.keys(zip.files).find((n) => /\.kml$/i.test(n) && !zip.files[n]?.dir);
  if (!entry) throw new Error("В KMZ не найден файл .kml");
  const text = await zip.files[entry]!.async("string");
  return parseKmlText(text);
}

export async function featureCollectionToKml(
  fc: GeoJSON.FeatureCollection,
): Promise<string> {
  const { toKML } = await import("@tmcw/tokml");
  return toKML(fc);
}

export function downloadKml(filename: string, kmlText: string): void {
  const blob = new Blob([kmlText], {
    type: "application/vnd.google-earth.kml+xml;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".kml") ? filename : `${filename}.kml`;
  a.click();
  URL.revokeObjectURL(url);
}
